<div class="facebook-callback-container" [testId]="'facebook-callback-container'">
  <!-- 加載狀態 -->
  <div *ngIf="loading" class="loading-container" [testId]="'loading-container'">
    <div class="loading-card" [testId]="'loading-card'">
      <div class="loading-icon" [testId]="'loading-icon'">
        <nz-spin nzSize="large" [testId]="'loading-spinner'" />
      </div>
      <div class="loading-content" [testId]="'loading-content'">
        <h2 [testId]="'loading-title'">
          {{ 'facebook-callback.connecting' | i18n }} {{ channelType === 'Facebook' ? 'Facebook' : 'Instagram' }}
        </h2>
        <p [testId]="'loading-description'">{{ 'facebook-callback.verifying-identity' | i18n }}</p>
        <div class="loading-progress" [testId]="'loading-progress'">
          <div class="progress-bar" [testId]="'progress-bar'"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- 頁面選擇內容 -->
  <div
    *ngIf="!loading && (processingStatus === 'user_loaded' || processingStatus === 'pages_loaded')"
    class="content-container"
    [testId]="'content-container'"
  >
    <!-- 頁面標題 -->
    <div class="header" [testId]="'header'">
      <div class="title" [testId]="'page-title'"
        >{{ 'facebook-callback.connect' | i18n }}
        {{ channelType === 'Facebook' ? ('facebook-callback.facebook-page' | i18n) : ('facebook-callback.instagram-page' | i18n) }}</div
      >
    </div>

    <!-- Facebook 頁面選擇區域 -->
    <div class="pages-section" *ngIf="channelType === 'Facebook'" [testId]="'facebook-pages-section'">
      <nz-table
        #pagesTable
        [nzData]="facebookPages"
        [nzShowPagination]="false"
        [nzFrontPagination]="false"
        [nzLoading]="pagesLoading"
        [testId]="'facebook-pages-table'"
      >
        <thead>
          <tr>
            <th scope="col" [nzWidth]="'32px'" [testId]="'facebook-table-header-select'"></th>
            <th scope="col" [nzWidth]="'68px'" [testId]="'facebook-table-header-avatar'">{{ 'facebook-callback.avatar' | i18n }}</th>
            <th scope="col" [testId]="'facebook-table-header-id'">{{ 'facebook-callback.page-id' | i18n }}</th>
            <th scope="col" [testId]="'facebook-table-header-name'">{{ 'facebook-callback.page-name' | i18n }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let page of facebookPages">
            <td>
              <nz-radio-group [(ngModel)]="selectedPageId" [testId]="'facebook-page-radio-group'">
                <label nz-radio [nzValue]="page.id" [testId]="'facebook-page-radio-' + page.id"></label>
              </nz-radio-group>
            </td>
            <td>
              <nz-avatar [nzSize]="22" [nzSrc]="page.picture?.data?.url ?? ''" [testId]="'facebook-page-avatar-' + page.id" />
            </td>
            <td>{{ page.id }}</td>
            <td>{{ page.name }}</td>
          </tr>
        </tbody>
      </nz-table>
    </div>

    <!-- Instagram 頁面選擇區域 -->
    <div class="pages-section" *ngIf="channelType === 'Instagram'" [testId]="'instagram-pages-section'">
      <nz-table
        #instagramTable
        [nzData]="instagramPages"
        [nzShowPagination]="false"
        [nzFrontPagination]="false"
        [nzLoading]="pagesLoading"
        [testId]="'instagram-pages-table'"
      >
        <thead>
          <tr>
            <th scope="col" [nzWidth]="'32px'" [testId]="'instagram-table-header-select'"></th>
            <th scope="col" [nzWidth]="'68px'" [testId]="'instagram-table-header-avatar'">{{ 'facebook-callback.avatar' | i18n }}</th>
            <th scope="col" [testId]="'instagram-table-header-id'">{{ 'facebook-callback.account-id' | i18n }}</th>
            <th scope="col" [testId]="'instagram-table-header-name'">{{ 'facebook-callback.account-name' | i18n }}</th>
            <th scope="col" [testId]="'instagram-table-header-linked-page'">{{ 'facebook-callback.linked-facebook-page' | i18n }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let page of instagramPages">
            <td>
              <nz-radio-group [(ngModel)]="selectedPageId" [testId]="'instagram-page-radio-group'">
                <label nz-radio [nzValue]="page.id" [testId]="'instagram-page-radio-' + page.id"></label>
              </nz-radio-group>
            </td>
            <td>
              <nz-avatar [nzSize]="22" [nzSrc]="page.profile_picture_url ?? ''" [testId]="'instagram-page-avatar-' + page.id" />
            </td>
            <td>{{ page.id }}</td>
            <td>{{ page.username }}</td>
            <td>{{ page.fansPageName }}</td>
          </tr>
        </tbody>
      </nz-table>
    </div>

    <!-- 底部按鈕區域 -->
    <div class="footer" [testId]="'footer'">
      <div class="action-buttons" [testId]="'action-buttons'">
        <button nz-button nzType="default" (click)="closeWindow()" [testId]="'cancel-button'">
          {{ 'facebook-callback.cancel' | i18n }}
        </button>
        <button nz-button nzType="primary" [disabled]="!selectedPageId" (click)="confirmSelection()" [testId]="'connect-button'">{{
          'facebook-callback.connect-btn' | i18n
        }}</button>
      </div>
    </div>
  </div>

  <!-- 錯誤狀態 -->
  <div *ngIf="!loading && processingStatus === 'error'" class="error-container" [testId]="'error-container'">
    <div class="error-card" [testId]="'error-card'">
      <div class="error-icon" [testId]="'error-icon'">
        <i nz-icon nzType="exclamation-circle" nzTheme="fill" [testId]="'error-icon-element'"></i>
      </div>
      <div class="error-content" [testId]="'error-content'">
        <h2 [testId]="'error-title'">{{ 'facebook-callback.connection-failed' | i18n }}</h2>
        <p [testId]="'error-description'">{{ error ?? ('facebook-callback.login-error-retry' | i18n) }}</p>
      </div>
      <div class="error-actions" [testId]="'error-actions'">
        <button nz-button nzType="default" (click)="closeWindow()" [testId]="'error-close-button'">
          {{ 'facebook-callback.close' | i18n }}
        </button>
      </div>
    </div>
  </div>
</div>
